import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MunilyAlertType } from 'src/app/common-components/alert/alert.types';

@Component({
  selector: 'app-alert-playground',
  templateUrl: './alert-playground.component.html',
  styleUrls: ['./alert-playground.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertPlaygroundComponent {
  type: MunilyAlertType = 'info';
  showDescription = true;
  emphasisText = 'Emphasis text goes here.';
  description = 'Description text goes here.';
  widthLayout: 'fixed' | 'fill' = 'fixed';
}

